export default __webpack_public_path__ + "static/media/car.15ee9a07.svg";